<template>
  <div class="bind-email-container">
    <van-nav-bar :title="$t('coinbase_he_tit1')" left-text="返回" left-arrow>
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
    </van-nav-bar>
    <div class="content">
      <div class="input-row">
        <div class="input-row-top">
          {{ $t("coinbase_he_tit2") }}
        </div>
        <div class="input-row-bot">
          <input
            type="text"
            v-model="email"
            :placeholder="$t('coinbase_he_tit5')"
          />
        </div>
      </div>
      <div class="input-row" v-if="!userInfo.email">
        <div class="input-row-top">
          {{ $t("tokpiedex_he_tit3") }}
        </div>
        <div class="input-row-bot">
          <input
            type="text"
            v-model="code"
            :placeholder="$t('code_placeholder')"
          />
          <div v-if="!count" @click="sendEmailCode" class="send-code">
            {{ $t("coinbase_he_tit4") }}
          </div>
          <div v-if="count" class="send-code">
            <van-count-down @finish="finish" :time="60000" format="ss" />S
          </div>
        </div>
      </div>
      <div class="confirm-btn" @click="setEmail" v-if="!userInfo.email">
        {{ $t("confirm") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      code: "",
      count: false,
      userInfo: ''
    };
  },
  created() {
    if(JSON.parse(localStorage.getItem('userInfo'))) {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      this.email = JSON.parse(localStorage.getItem('userInfo')).email
    }
  },
  methods: {
    finish() {
      this.count = false;
    },
    navBack() {
      this.$router.replace('/');
    },
    async sendEmailCode() {
      this.$Toast.loading({ forbidClick: true })
      const res = await this.$api.sendEmailCode({ email: this.email });
      if (res.code == 200) {
        this.count = true;
      }
    },
    async setEmail() {
      let data = {
        email: this.email,
        code: this.code
      }
      const res = await this.$api.setEmail(data)
      if(res.code == 200) {
        this.getUserInfo()
      } else {
        this.$Toast(res.message)
      }
    },
    async getUserInfo() {
      const res = await this.$api.getUserInfo();
      if (res.code == 200) {
        this.userInfo = res.data
        localStorage.setItem("userInfo", JSON.stringify(res.data));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  width: 30px;
  height: 15px;
}
.bind-email-container {
  .content {
    height: calc(100vh - 46px);
    padding: 60px 15px 0;
    box-sizing: border-box;
    background: #fff;
    .input-row {
      margin-bottom: 20px;
      &-top {
        font-size: 16px;
        font-weight: bold;
      }
      &-bot {
        padding: 12px 10px;
        background: #f2f4f7;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 3px;
        margin-top: 15px;
        input {
          color: #333;
          flex: 1;
          border: none;
          font-size: 14px;
          background: transparent;
        }
        .send-code {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #0062f8;
        }
      }
    }
    .confirm-btn {
      width: 100%;
      margin-top: 40px;
      background: #0062f8;
      text-align: center;
      color: #fff;
      padding: 10px 0;
      font-size: 16px;
      border-radius: 3px;
    }
  }
}
@media (min-width: 640px) {
  /deep/ .van-nav-bar--fixed {
    width: 540px;
    left: unset;
  }
  /deep/ .van-nav-bar__content {
    height: auto;
  }
  .back {
    width: 30px;
    height: 15px;
  }
  .bind-email-container {
    .content {
      height: calc(100vh - 46px);
      padding: 60px 15px 0;
      box-sizing: border-box;
      background: #fff;
      .input-row {
        margin-bottom: 20px;
        &-top {
          font-size: 16px;
          font-weight: bold;
        }
        &-bot {
          padding: 12px 10px;
          background: #f2f4f7;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-radius: 3px;
          margin-top: 15px;
          input {
            color: #333;
            flex: 1;
            border: none;
            font-size: 14px;
            background: transparent;
          }
          .send-code {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #0062f8;
          }
        }
      }
      .confirm-btn {
        width: 100%;
        margin-top: 40px;
        background: #0062f8;
        text-align: center;
        color: #fff;
        padding: 10px 0;
        font-size: 16px;
        border-radius: 3px;
      }
    }
  }
}
</style>